import React from 'react'
import styled from 'styled-components'

const Card: React.FC<{color?:string,borderRadius?:number}> = ({color,children,borderRadius}) => <StyledCard color={color} borderRadius={borderRadius}>{children}</StyledCard>;

const StyledCard = styled.div<{color?:string,borderRadius?:number}>`
  background: ${(props)=>props.color || 'rgba(20, 33, 68, 1)'};
  border-radius: ${(props)=>props.borderRadius || 5}px;
  display: flex;
  flex: 1;
  
  border: 1px solid #273761;
  flex-direction: column;
   @media (max-width: 768px) {
    width: 96%; 
    margin: 0 auto;
  }
  //&:hover{
  //background: RGBA(247, 247, 247, 1);
  //}
`;

export default Card
